export enum KnowEdmTableData {
  ModelName = 'model_name',
  GravityFieldModel = 'gravity_field_model', // does not exist in EDM files
  ReferenceDate = 'declination_date',
  DipAngle = 'dip_angle',
  Declination = 'declination',
  GravityField = 'gravitational_field', // does not exist in EDM files
  MagneticField = 'field_strength',
  EarthsRotationalRate = 'earth_rotational_rate', // does not exist in EDM files
  Depth = 'Depth',
  TermA = 'TermA',
  TermB = 'TermB',
  NEVNN = 'NEVNN',
  NEVNE = 'NEVNE',
  NEVNV = 'NEVNV',
  NEVEE = 'NEVEE',
  NEVEV = 'NEVEV',
  NEVVV = 'NEVVV',
  INC = 'INC',
  AZI = 'AZI',
  HSError = 'HSError',
  LateralError = 'LateralError',
  AHError = 'AHError',
  VerticalError = 'VerticalError',
  SemiMajorError = 'SemiMajorError',
  SemiMinorError = 'SemiMinorError',
  SemiMinorAzimuth = 'SemiMinorAzimuth',
  ToolName = 'ToolName',
}

export enum KnowTableData {
  DepthMD = 'depthMD',
  Inclination = 'inclination',
  Azimuth = 'azimuth',
  DepthTVD = 'depthTVD',
  HighSideError = 'highSideError',
  LateralError = 'lateralError',
  AlongHoleError = 'alongHoleError',
  VerticalError = 'verticalError',
  SemiMajorError = 'semiMajorError',
  SemiMinorError = 'semiMinorError',
  SemiMinorAzimuth = 'semiMinorAzimuth',
  ToolIPMFileName = 'toolIPMFileName',
  NevNN = 'nevNN',
  NevNE = 'nevNE',
  NevNV = 'nevNV',
  NevEE = 'nevEE',
  NevEV = 'nevEV',
  NevVV = 'nevVV',
  TermName = 'termName',
  VectorEX = 'vectorEx',
  VectorEY = 'vectorEy',
  VectorEZ = 'vectorEz',
  VectorEStarX = 'vectorEStarx',
  VectorEStarY = 'vectorEStary',
  VectorEStarZ = 'vectorEStarz',
  VectorType = 'vectorType',
  LegIndex = 'legIndex',
}
